/**
 * @example
 *  - ['subscription', 'list', <filters>]
 */
const SubscriptionQueryKeys = {
  list: (filters?: Record<string, unknown>) =>
    ['subscription', 'list', ...(filters ? [filters] : [])] as const
};

export default SubscriptionQueryKeys;
